module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre1"
  }, [_vm._v("Opfergesang")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('i', {
    staticClass: "calibre7"
  }, [_vm._v("(Königspalast zu Argos. Auf dem flachen Dach der Wächter)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Wächter:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Götter bitt ich um Erlösung dieser Mühn"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der langen Jahreswache, die ich, lagernd hier"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im Dach des Atreushauses wie ein Wächterhund,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der stillen Sterne Nachtverkehr mit angesehn,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und die den Menschen Winter bringen und Sommerzeit,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die hellen Führer, funkelnd durch des Äthers Raum."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und wieder späh ich nach des Flammenzeichens Schein,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dem Strahl des Feuers, das von Troja Kunde bringt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und Siegesnachricht; also, denk ich, hat es mir"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Geboten meiner Herrin männlich ratend Herz."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und halt ich so hier meine nachtgestörte Ruh,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Vom Tau durchnäßt, nie mehr von Träumen aufgesucht,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So steht ja statt des Schlafes neben mir die Furcht,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zufallen könnte gar im Schlaf mein Augenlid."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und wenn ich ein Lied mir singen oder pfeifen will,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den besten Schlaftrunk für den Wachestörer Schlaf,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So wein ich seufzend über dieses Hauses Los,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das nicht, wie sonst wohl, allem Wetter glücklich trotzt."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So käm erwünscht mir meiner Müh Erlösung jetzt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Erschien' des nächtgen, botenfrohen Feuers Schein."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', [_vm._v("(Auf den Bergen steigt eine Flamme auf)")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  O sei gegrüßt mir, Licht der Nacht! Taghelle Lust"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Weckst du in mir, erweckst in Argos weit und breit"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Festchorgesänge, diesem Glück zum Dank geweiht!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Hoiho, hoiho!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Agamemnons Gattin will ich es laut verkündigen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Daß schnell ihr Lager sie verlasse, im Palast"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den freudenhellsten Jubel diesem Feuerschein"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Entgegenjauchze, da die Troerfeste ja"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gefallen ist, wie dort der Schein es hell erzählt!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dann will ich selbst beim Fest den Vortanz halten; mir"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Auch klecken soll's, daß meiner Herrschaft Würfel jetzt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gut fiel; die achtzehn Augen bringt mein Spähen mir."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nun aber will ich meines Fürsten liebe Hand,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des Heimgekehrten, schütteln hier mit dieser Hand;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Vom andern schweig ich; mir verschließt ein golden Schloß"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den Mund; das Haus selbst, wenn es sprechen könnte, würd"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Am besten ihm erzählen; denn der's weiß, mit dem"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Besprech ich gern; für den, der's nicht weiß, schweig ich gern."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('span', [_vm._v("(Wächter ab)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', [_vm._v("(Der Chor der Greise tritt auf)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chorführer:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zehn Jahre nun sind's,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Seit Priamos' mächtiger Richter, der Fürst"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Menelaos, mit ihm Agamemnon zugleich,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das erhabene Paar der Atriden, in Zeus'"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zweithroniger Macht, Zweizeptergewalt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Argiver tausendschiffigen Zug"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von jenem Gestad"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Fortführten, Genossen des Krieges.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Voll Zornmut schrien sie gewaltigen Kampf,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie der Weih des Gebirgs im verwilderten Schmerz"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Um die Brut hoch hin sein einsam Nest"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Unermüdlich umkreist,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In der Fittiche ruhendem Ruder gewiegt;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der ins Nest bannenden,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Für die Küchlein der Sorge verwaiset!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Doch droben ein Gott, ist's Pan, ist's Zeus,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ist es Apollon, er vernimmt des Geschreis"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Weithallenden Schmerz um die fehlende Brut;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Vergelterin schickt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Erinnys, er dem Verruchten!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Also zum Gericht Alexanders hat Zeus,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So des Gastrechts Hort, die Atriden gesandt;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So läßt um das männerumbuhlete Weib"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Unablässigen, gliederzerschmetternden Kampf,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das ermattende Knie an den Boden gestemmt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In des Vorkampfs Tosen die Lanze zerschellt –"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So läßt er die Danaer kämpfen,")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Und die Troer zugleich! Mag's immer denn sein,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie es sei; es erfüllt das Verhängte sich doch,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nicht Spend und Gebet, nicht Zauber beschwört,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nicht Tränen vertilgen den lauernden Zorn"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der sühnevergessenen Gottheit!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Doch wir, kraftlos mit gealtertem Leib,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die vom Zuge zurück man damals ließ,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wir weilen daheim,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die kindische Kraft mit dem Stabe gestützt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn das jugendlich rüstige Mark in der Brust,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das zur Tat anfacht, alt ist's; hier wohnt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nicht Kampflust mehr."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wer dem Alter erliegt, wem herbstlich die Stirn"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sich entlaubet, er wankt dreifüßigen Gang,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nicht kräftiger mehr denn ein kraftlos Kind,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ein tagumwandelndes Traumbild!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', [_vm._v("(Aus der königlichen Pforte ist ein festlicher Zug Dienerinnen getreten. Dann erscheint die Königin Klytaimestra)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chorführer:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Doch, Königin, sprich,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Du des Tyndaros Kind, Klytaimestra, was ist?"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Was Neues geschah?"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Auf welches Gerücht, auf wessen Bericht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ist's, daß du die Opfer verteilest?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Und den Göttern zumal, den Beschirmern der Stadt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Himmlischen, Unteren,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den Behütern des Markts, den Olympiern flammt's"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von Geschenken auf jeglichem Altar!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Und hüben und drüben zum Himmel empor"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Steigt flackernde Glut,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Mit des heiligen Öls duftsüßem Getröpf,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie mit arglos schmeichelndem Zauber getränkt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Mit dem Weihöl fürstlicher Habe!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("So sage davon, was kund mir zu tun"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Du vermagst und du willst!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So werde du mir der Besorgnis Arzt!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Was mich bang jetzt läßt in die Zukunft sehn,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Jetzt heiter im Schein sich der Opfer erhellt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dies Hoffen, die weitere Sorge verbeut's,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den geheim herznagenden Kummer!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', [_vm._v("(Das Opfer beginnt)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_c('span', [_vm._v("Opfergesang")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Erste Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ich darf singen der herrlichen, zeichenbegünstigten Fürsten"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Glückliche Fahrt – denn es haucht mir Vertraun zu den Göttern"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dies Festlied ein,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Kraft inwohnendes Alter –,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie einst die zwiethronige Kraft der Achaier, der griechischen Jugend"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Einige Feldherrn,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Fort mit Speer und mit rächendem Arme der Vogel des Mutes"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sandte gen Troja,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Luftkönig die Könge der See:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der im schwarzen Gefieder voran, der im schneeweißen Fittich"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihm nach zum Palast an der Lanzenseite;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Auf weitschauendem Horste"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Saßen sie, weideten dort vom Geweide der tragenden Häsin,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im letzten Lauf zum Tod erhascht."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ailinon, Ailinon rufet! Das Gute siege!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Erste Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Und der erfahrene Seher, die zwei einmütigen, kühnen"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Fürsten erkennend, erkannte die Hasenverschlinger,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des Zugs Führer;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Also sprach er die Deutung:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  \"Wohl wird dereinst Priamos' Feste die Beute der Heerfahrt;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Alle des Schlosses,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Alle des Volkes gesammelte Schätze, sie wird mit Gewalt einst"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Rauben die Moira;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So hat nimmer der Ewigen Neid"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die gefährdeten Wälle mit Heeresgewalt so nie umnachtet!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die lautere Artemis zürnt dem Hause,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den Flugdienern des Vaters,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Weil mit der Frucht sie die tragende, zagende Mutter geopfert;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sie haßt der Adler arges Mahl!\""), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ailinon, Ailinon rufet! Das Gute siege!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Epode")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("\"So treuen Sinns schirmt die Holde"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des zürnenden Leun ungeborne Brut,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sorgt für alle des heidedurchfliehnden Wildes saugende Jungen!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Enden wird sie, was Gunstreiches der Aare"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zeichen zugleich so erfreuend, so dräuend verkündet!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dem Helfer will ich, dem Paian rufen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Daß sie den Danaern nimmer ermüdender, widriger Winde Fahrthemmung zusend,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Lüstern nach anderem Opfer, geweiht mit Verstummen und Blutschuld,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Heimlichen, keimenden Hasses Geburt, mannscheulos Freveln, da furchtbar"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sein die empörte, mißehrte,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Tückische Herrin im Haus,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Schlaflos kindrächende Wut harrt!\""), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Also geweissagt wurde von Kalchas zu freudigstem Glücke"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Böses aus fahrtvordeutendem Aar dem Hause der Fürsten."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Diesem ein gleiches"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ailinon, Ailinon rufet! Das Gute siege!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Zweite Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Zeus, wer Zeus auch immer möge sein, ist er dieses Namens froh,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Will ich gern ihn nennen so;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihm vergleichen kann ich nichts, wenn ich alles auch erwäg,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Außer ihm selbst – wenn des Denkens vergebliche Qualen"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ich in Wahrheit bannen will!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Zweite Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("So, wer ehedem gewaltig war, allbewerten Trotzes hehr,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Was er war, nicht gilt es mehr;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der darauf erstand, dem Allsieger unterlag auch der."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Aber den Zeus im Gesange des Sieges zu preisen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Alles Denkens Frieden ist's!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Dritte Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ihn, der uns zum ernsten Nachsinnen leitet, uns in Leid"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Lernen läßt zu seiner Zeit;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Drum weint auch im Traum im Herzen noch"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Kummer leideingedenk, und es keimt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wider Willen weiser Sinn."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wohl heißt streng und schonungslos der ewgen hochgethronten Götter Gunst!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Dritte Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Gleiches hat des Griechenzugs ältrer Führer kummervoll,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Seinem Seher sonder Groll,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ringsandräundem Kummer ernst bereit,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Als in ruhmloser Rast fahrtgehemmt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Schwierig schon das Griechenheer,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  An dem Aulisstrand gelagert, rückwärts Chalkis' Brandung strömen sah –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Vierte Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Vom Strymon her wehten da die Winde"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Rastloser Rast, hafenlosen Treibens,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des Zugs Verzug,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Für Tau und Kiel immer neu Gefährde;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In trostlos langer Säumnis welkend,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Schwand auch des Heers blühnde Jugend schon dahin;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und als ein Mittel nun,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ärger den Fürsten selbst als ärgster Verzug, der Seher,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Artemis' Zorn deutend, erfand, und sie den Stab tief in den Sand"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Stießen und selbst Tränen sie nicht hemmten, des Atreus Söhne –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Vierte Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Da also sprach dieses Wort der Ältre:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  \"Ein hartes Los ist es, nicht zu folgen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und hart, daß ich"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Soll schlachten mein Kind, des Hauses Kleinod,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Am Altar tauchen meine Hand soll,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Vaterhand, in der Tochter Opferblut!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Was ist von Schmerzen frei?"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Soll ich das Heer verraten? Täuschen die Kampfgenossen?"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Daß sie das windstillende Sühnopfer, das jungfräuliche Blut"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wilden Geschreis fordern, gerecht ist es; es stünde gut dann!\"")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Fünfte Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Als er dem Joch so der Not sich beugte,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Als er der unselgen Sinneswandlung"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nachdachte, der arg unheilgen, da"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ergriff er kühn allzukühnen Vorsatz!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn so emporstachelt den Menschen ein erster Irrtum, den er begeht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sinnverstört. Sinnbetört trug er's nun,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sein Kind schlachten zu sehn für jenen weibstrafenden Krieg, der Meerfahrt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Bräutliche Totenweihe!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Fünfte Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ihr Bitten nicht, nicht ihr \"Vater\" Rufen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nicht ihre jungfräulich süße Jugend"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Erbarmte der Feldherrn wilden Mut;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Vater sprach sein Gebet; er hieß sie"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den Diener hoch auf dem heilgen Herd niederhalten, in das Gewand"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Tiefverhüllt, vorgebeugt, ziegengleich,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Befahl streng zu bewachen ihren schönrosigen Mund, daß nicht sie"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Jammernd ihr Haus verfluche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Sechste Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Sie schwieg dem Machtwort in lautlosem Zwang;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihr Safrankleid ließ sie niederfließen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und sah mit wehmütgem Blick bang zu jedem bittend ihrer Opfrer,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Als ob sie so mahnen wie ein stummes Bild"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihn jetztan sonst wollte, wo"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im goldnen mahlreichen Vätersaal sie"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Jungfräulich blöd sang ihr Lied, in des Gesangs kindlich frommer Lust"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des vielteuren Vaters dreimal seliges Los zu preisen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Sechste Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Was drauf geschah, sah ich nicht, sag ich nicht;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Doch unerfüllt bleibet Kalchas' Wort nicht!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn Dike wägt je für Leid auch Belehrung zu. Die Zukunft –"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wer beugt ihr aus? – mag voraus ich nimmer schaun;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dem wär voraustrauern gleich;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn klar dem Ausspruch entsprechend kommt sie!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Was muß geschehn, wenden mag sich es zum Heil, falls es gönnen will,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der hier nächster Hort uns weilt, des apischen Landes Schirmherr!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chorführer:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ich nah in Ehrfurcht, Klytaimestra, deiner Macht;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das ist gerecht, zu ehren seines Königes"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gemahlin, wenn verwaist ist seines Herrn der Thron."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Doch ob du nun Glaubwürdges hörtest oder nicht,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Daß du in botschaftsfroher Hoffnung opfertest,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das gern erführ ich; aber schweigst du, kränkt's mich nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ein Evangelium, wie's im Sprichwort heißet, ward"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das Morgenrot uns von der Mutter Nacht gesandt."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ja, Freude höret über alle Hoffnung groß:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Achaier nahmen ein die Stadt des Priamos!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Was ist? Das Wort entging mir aus Unglaublichkeit!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In der Griechen Hand ist Troja! Sprach ich nun es klar?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Es ergreift mich Freude, Tränen ruft sie mir hervor!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Daß du es wohl meinst, zeigt dein Aug mir unverstellt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sprich, hast du Zeugnis dessen, sicher und gewiß?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gewiß, was sonst denn? Wenn ein Gott mich nicht betrog.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Du ehrst vielleicht ein überredend Traumgesicht?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nie würd ich Glauben schlafestrunkenem Sinne leihn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So macht ein schnellbeschwingt Gerücht dich wohl so froh?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Als wär ich ein kindisch Mädchen, so verhöhnst du mich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zu welcher Zeit war's, daß die Stadt vernichtet ward?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In dieser Nacht war's, welche diesen Tag gebar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Doch welcher Bote mochte sich so schleunig nahn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Hephaistos, der vom Ida hellen Strahl gesandt!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn hergeschickt hat in der Feuer Wechselpost"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ein Brand den andern. Ida selbst zum Hermesfels,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In Lemnos; von der Insel her zum dritten nahm"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den breiten Lichtstrahl auf des Zeus Athosgebirg."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Hochleuchtend, daß der Wanderin Flamme mächtger Schein"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Weithin der Meerflut Rücken überflog, ein Brand"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Freude, ward goldstrahlend, einer Sonne gleich,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zur Warte von Makistos dann das Licht gesandt."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die schürte weiter, säumig nicht noch unbedacht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Vom Schlaf bewältigt, ihren Botenteil hinaus."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und wieder fernhin eilend gen Euripos' Flut"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Rief auf der Strahl die Wächter auf Messapios."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die dann entbrannten und entsandten neuen Schein,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Graias Haufen Heidekraut anzündete."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die rüstge Flamme, nicht ermüdet noch geschwächt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sie eilte weithin über Asopos' Ebene,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gleich hellem Mondlicht, gen Kithairons Felsenstirn"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und weckte schnell der Feuerboten Wechsel auf."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Fernhin erkennbar neue Flamme schürte dort"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Wache; hoch schlug dann das hellste Feuer auf"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und warf den Glanz weit über den Gorgopis-See."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Auf Aigiplanktos' Scheitel treffend trieb es an,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des Fanales Lichtbahn nicht zu stören; schnell geschah's;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sie sandten glutanschürend zu wolkenglühndem Schein"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den mächtgen Schweif der Flamme, daß er fernhinaus"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die weite Spiegelfläche des saronischen"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Meerbusens leuchtend überstrahlte, bis er kam"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zu Arachnaions Gipfel nah bei unsrer Stadt."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von dort ergoß dies Feuer sich in dieses Schloß"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Atriden, echter Enkel der idäischen Glut."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So war die Ordnung dieses Fackellaufs bestimmt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und, so mit Flamme Flamme wechselnd, schnell erfüllt;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im Flammenlauf die erst und letzte hat den Preis."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ein solches Zeugnis, solches Zeichen nenn ich dir,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Aus Troja mir voraus von meinem Mann gesandt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die Götter, Herrin, preisen will ich sie demnächst;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Doch anzuhören, zu bewundern jenes Wort"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von neuem, möcht ich, daß von neuem du es sprächst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Klytaimestra:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  's ist Ilion der Griechen Beute diesen Tag!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ich glaub, ein unvermischt Geschrei durchhallt die Stadt;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gießt Öl und Essig du in einen Krug, so siehst"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Du sie geschieden fort und fort und nicht vereint;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So wird der Sieger, so der Besiegten Rufen dort"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Geschieden, so zwiefachen Loses Zeichen sein."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die einen tiefgebeuget bei den Leichen der"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Erschlagnen Männer, der Geschwister, und das Kind"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Beim greisen Vater, sie beklagen nimmermehr"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Mit freier Kehle dies Geschick der Teuersten."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die andern, nachtdurchirrend, hungermatte Gier"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Hat sie zum Imbiß, wie und wo die Stadt ihn beut,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Verwildert, reihlos Reih und Glied, umherzerstreut;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie jeder je das Los des Glückes sich gewann,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So hausen sie in Trojas speererrungenen"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Palästen, für des freien Feldes Lagerplatz"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und kalten Tau ein guter Tausch – die Glücklichen!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die ganze Nacht durch schlafen sie nun unbewacht."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und ehren jetzt sie jenes Landes, jener Stadt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Besiegten Götter und der Götter Tempel, dann"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Vielleicht erliegt der Sieger nicht dem eignen Sieg."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Doch reize nicht Begier zu früh das Heer, besiegt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von schnöder Habsucht mehr zu wollen, als es darf;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Es braucht zur Heimkehr noch zurück die zweite Fahrt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Bevor des Seezugs Doppelbahn vollendet ist."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und käme schuldlos auch den Göttern heim das Heer,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wach könnte dennoch werden der Erschlagnen Blut,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Geschäh hinfort auch keine neue Freveltat. –"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von mir, von einem Weibe, habe das gehört!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das Gute siege, jedem Blick unzweifelhaft!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Mit teuren Opfern hab ich solchen Wunsch erkauft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Du sprachst, o Herrin, würdig eines würdgen Manns;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ich aber will den Göttern, da mich überzeugt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dein früher Zeugnis, singen meinen frohen Dank;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn fromm erkannt sei's, wenn sich Mühe so belohnt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chorführer:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Allherrschender Zeus und du, freundliche Nacht,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Du Spenderin leuchtenden Schmuckes,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Die du fest anzogst um Ilions Burg"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dein fangendes Garn,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und keiner entkam, nicht klein noch groß,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dem gewaltigen Netze der Dienstbarkeit,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dem alles erfassenden Unheil!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dich, gastlicher Zeus, hoch ehr ich auch dich,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der du das zu erfüllen an Priamos' Sohn"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Längst hieltest den Bogen der Rache gespannt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Daß weder zu früh noch ins Dunkel der Nacht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ein eitel Geschoß hinschwirrte!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Erste Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("Chor:")]), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie Zeus traf, wissen sie zu sagen;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Auch das vermag man aufzuspüren:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Er hat's vollbracht, zu enden!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Meinet nicht, daß die Götter den"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihrer Sorg würdigen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der unverletzbares Recht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zertrat – und der scheute's nicht!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Beweis ward sein Geschlecht,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Das tollkühn Kampf gewagt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im Kriegsmut wilder denn gerecht war,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im Hochmut überstolzen Glückes,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im Übermaß schuldig!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sei mein Geschick niedrig, sei der Armut"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Reines Gewissen gnug mir!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Schutz nicht bietet der Reichtum"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dem, der, Glückes gesättigt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Frech zertrat der Gerechtigkeit Altar, gegen Vernichtung!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Erste Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Gewaltsam treibt die arge Peitho,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Betörend emsig Kind des Unheils;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  's ist Rettung allvergeblich!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nie verglimmt, hell, ein lodernd Feuer,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Grausig hell zeugt die Schuld!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gleich schlechter Goldmünze nützt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gebrauch und Zeit prüfend ab"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Den Goldschein, falsch gemünzt!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn nachlief, knabenhaft"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Betört, "), _c('i', {
    staticClass: "calibre7"
  }, [_vm._v("der")]), _vm._v(" schnellbeschwingtem Vogel,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Heimat bittrer Prüfung Anfang!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihr Jammern hört keiner"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Der Götter an, sondern zürnend trifft er"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Jenen, des Frevels Anfang!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Also Paris, der damals"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gast im Haus der Atriden"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Frech den gastlichen Tisch entweiht, der die Gattin entführt hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Zweite Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Dem Volk daheim ließ sie kriegsrüstgen Lärm"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und Schildesklang, Speergedräng, Schiffsgeschrei am Strande,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nahm Ilions Verderben mit als Brautgeschenk;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So floh sie durch die Pforte dahin,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Verwegnes wagend. Und es schrien laut,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wehklagten laut ihres Hauses Seher:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  \"O Haus! O Haus! Wehe, weh dir, Fürstenstamm!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Weh, bräutlich Bett! Spuren toter Liebe, weh euch!\""), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dort er, beschimpft schweigend, sonder Zorn und Groll,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Süßträumend, die er verlor, zu schauen,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Er wähnt voll Sehnsucht, die Meerentflohne"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Walt' im Geist noch daheim im Hause;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Alles heiligen Bildes"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Anmut ist ihm zuwider,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ihres Auges verlorne Lust aller Liebe Verlust ihm!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Zweite Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Und traumverwebt, trauerreich umschweben"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Gestalten ihn, seines Grams wunderholdes Trugspiel."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So trughaft, wenn du Liebstes wähnst zu schaun,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So flüchtig deinen Händen entflohn"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Verfliegt, verschwindet dir mit leisem Flügel"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Dein Traumgesicht weit in Schlafes Weiten."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Also der Gram an des Fürstenhauses Herd;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Schon der so groß – und ein andrer größer noch!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn wer aus griechischem Lande mitgezogen ist,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Endloses Grämen weilt daheim"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  In seinem Haus Tag und Nacht;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Vieles nagt tief am tiefsten Herzen:"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Denn wen jeder dahingab,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Weiß er; aber zurückkehrt"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Statt des Mannes in jeglich Haus sein Gewaffen und Asche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Dritte Strophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ares, der Leichname Goldwechsler ist's,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Im Kampf des Speers blutger Todeswäger,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Von Troja heimsendet er den Lieben"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ein kleines, trübselges Überbleibsel,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  An Mannes Statt mit Staub gefüllt schönverzierten Aschenkrug!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Drum jammern sie, sie preisen ihn aller Schlachten Tapfersten,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Sie rühmen, daß er herrlich fiel, kämpfend um fremden Mannes Weib!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  So in der Stille wird gemurrt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Und es beschleicht des Kampfes Urheber des Hasses Unheil."), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Aber wer in der Schlacht fiel,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ruht dort unter den Mauern,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Ruht im troischen Grabe; fern deckt ihn feindlicher Boden!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Dritte Gegenstrophe")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Gefährlich wächst Volkes Murren, grollgemischt,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zahlt zurück volkentpreßter Flüche Schuld;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Zu hören bangt meine Sorg ein Ende"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Endloser Nacht! Unerspäht den Göttern"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Bleibt nimmermehr, wer Blut vergoß, und der Erinnyen schwarze Schar"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Quält den, der glücklich wider Recht ist, einst mit unglückselger Fristung"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Des Lebens tot; geknechtet, so späht er umsonst nach Schutz umher;"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Selbst in des Ruhmes Übermaß"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Brütet Gefahr; denn seinen Blitz schleudert des Donnrers Neidblick!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Mein mag mäßiges Glück sein,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Nicht als Städtezertrümmrer"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Möcht ich, aber in Feindes Hand auch mich nimmer erblicken!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('h4', {
    staticClass: "calibre8"
  }, [_vm._v("Epode")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_vm._v("Ein botenfroh Feuer ließ"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Durch unsere Stadt schnell Gerücht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Eilen; aber ob es wahr, wer weiß es?"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wahrheit wahrlich ist der Götter nur!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wer wird so kindergläubig, so verblendet sein,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  An dieses Scheins neuer Kunde sein Gemüt erst zu wärmen, dann, getäuscht, bittren Tausches Bild zu sein?"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Für Weibes Witz paßt es, eh sie offenbar, schon zu preisen Glückes Gunst!"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Leichtgläubig zu leicht verbreitet sich Frauengeschwätz,"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Wie Windeswehn; doch windverweht"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  Versinkt zu Nichts weiberausposaunt Gerücht! –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b9fd0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chapter1.vue
// module id = 60
// module chunks = 0